const FETCH_GLOBAL_IMAGES_START = 'scratch-gui/bricklab-global-images/FETCH_GLOBAL_IMAGES_START';
const FETCH_GLOBAL_IMAGES_SUCCESS = 'scratch-gui/bricklab-global-images/FETCH_GLOBAL_IMAGES_SUCCESS';
const FETCH_GLOBAL_IMAGES_ERROR = 'scratch-gui/bricklab-global-images/FETCH_GLOBAL_IMAGES_ERROR';
const UPDATE_IMAGE_URLS = 'scratch-gui/bricklab-global-images/UPDATE_IMAGE_URLS';

const initialState = {
    categories: [],
    loading: false,
    error: null,
    lastFetched: null,
    imageUrlMap: {} // Map of S3 keys to signed URLs for caching
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
    case FETCH_GLOBAL_IMAGES_START:
        return {
            ...state,
            loading: true,
            error: null
        };
    
    case FETCH_GLOBAL_IMAGES_SUCCESS:
        return {
            ...state,
            categories: action.payload,
            loading: false,
            error: null,
            lastFetched: Date.now()
        };
    
    case FETCH_GLOBAL_IMAGES_ERROR:
        return {
            ...state,
            loading: false,
            error: action.payload
        };
    
    case UPDATE_IMAGE_URLS:
        return {
            ...state,
            imageUrlMap: {
                ...state.imageUrlMap,
                ...action.payload
            }
        };
    
    default:
        return state;
    }
};

const fetchGlobalImagesStart = () => ({
    type: FETCH_GLOBAL_IMAGES_START
});

const fetchGlobalImagesSuccess = categories => ({
    type: FETCH_GLOBAL_IMAGES_SUCCESS,
    payload: categories
});

const fetchGlobalImagesError = error => ({
    type: FETCH_GLOBAL_IMAGES_ERROR,
    payload: error
});

const updateImageUrls = urlMap => ({
    type: UPDATE_IMAGE_URLS,
    payload: urlMap
});

/**
 * Thunk action to fetch BrickLab global images
 * This will be called from components with dispatch
 * @param {boolean} includeSignedUrls - If true, returns signed URLs directly
 * @returns {Function} A function that takes dispatch
 */
const fetchBrickLabGlobalImages = (includeSignedUrls = false) => async dispatch => {
    // Import here to avoid circular dependencies
    const {fetchBrickLabGlobalImages: fetchImages, getSignedUrlsForKeys} = require('../lib/seeds-api');
    
    dispatch(fetchGlobalImagesStart());
    try {
        const data = await fetchImages(includeSignedUrls);
        
        if (data.success) {
            dispatch(fetchGlobalImagesSuccess(data.categories));
            
            // If S3 keys were returned, convert them to signed URLs
            if (!includeSignedUrls && data.categories) {
                const allS3Keys = data.categories.flatMap(category =>
                    category.images.map(img => img.imageUrl)
                ).filter(key => key && !key.startsWith('http')); // Only S3 keys, not already signed URLs
                
                if (allS3Keys.length > 0) {
                    const urlData = await getSignedUrlsForKeys(allS3Keys);
                    const urlMap = {};
                    urlData.results.forEach(result => {
                        if (result.success) {
                            urlMap[result.key] = result.url;
                        }
                    });
                    dispatch(updateImageUrls(urlMap));
                }
            }
        } else {
            throw new Error(data.error || 'Failed to fetch images');
        }
    } catch (error) {
        dispatch(fetchGlobalImagesError(error.message));
    }
};

export {
    reducer as default,
    initialState as bricklabGlobalImagesInitialState,
    fetchGlobalImagesStart,
    fetchGlobalImagesSuccess,
    fetchGlobalImagesError,
    updateImageUrls,
    fetchBrickLabGlobalImages
};
